import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

import moveSpreadContentUtil, { SpreadContentMove } from '../util/moveSpreadContentUtil';

const moveSpreadContentReducer = (state: DesignState, action: PayloadAction<{ moves: SpreadContentMove[] }>) => {
  const { designData } = state;
  if (!designData) {
    return;
  }

  moveSpreadContentUtil(designData, action.payload.moves);
};

export default moveSpreadContentReducer;
